import { computed } from '@vue/composition-api'
import numeral from 'numeral'

export default function usePostLoginInit (store, router) {
  // Computed values from store
  const userInfo = computed(() => {
    return store.getters.userInfo
  })

  const regionConfig = computed(() => {
    return store.getters.regionConfig
  })

  const defaultMetric = computed(() => {
    return store.getters.defaultMetric
  })

  const userDefaultInitView = computed(() => {
    return store.getters.userDefaultInitView
  })

  const userRole = computed(() => {
    return userInfo.value?.role
  })

  const isBasicUser = computed(() => {
    return userRole.value && ['Partner', 'Api Account'].includes(userRole.value)
  })

  const defaultView = computed(() => {
    return isBasicUser.value ? 'MassiveDownload' : 'Dashboard'
  })

  // Set up regional currency formatting
  const setRegionCurrency = () => {
    if (!regionConfig.value?.config?.currency) {
      console.warn('Region config or currency not available, defaulting to "ch"')
      numeral.locale('ch')
      return
    }

    const regionCurrency = regionConfig.value.config.currency
    if (regionCurrency === 'ch') {
      numeral.locale('ch')
    } else if (regionCurrency === 'pe') {
      numeral.locale('pe')
    } else if (regionCurrency === 'mx') {
      numeral.locale('mx')
    } else {
      numeral.locale('ch')
    }
  }

  // Initialize default metric in store
  const initializeDefaultMetric = () => {
    if (defaultMetric.value) {
      store.commit('commit_mainMetric', defaultMetric.value)
    }
  }

  // Determine where to route user after login based on device and role
  const getPostLoginRoute = (isMobile, isDesktop) => {
    if (isMobile) {
      // For mobile, show welcome screen with options
      return null // Don't auto-route, let user choose
    } else if (isDesktop) {
      // For desktop, route directly to user's default view
      return userDefaultInitView.value
    }
    return null
  }

  // Complete post-login initialization
  const performPostLoginInit = async (isMobile, isDesktop) => {
    try {
      // Wait for desktop parameter config to be loaded if not already
      if (!store.getters.isConfigLoaded) {
        await store.dispatch('fetchDesktopParameterConfig')
      }

      // Initialize currency formatting
      setRegionCurrency()

      // Initialize default metric
      initializeDefaultMetric()

      // Determine routing
      const route = getPostLoginRoute(isMobile, isDesktop)
      if (route && isDesktop) {
        router.push({ name: route })
      }

      return {
        shouldShowMobileWelcome: isMobile,
        routeTo: route
      }
    } catch (error) {
      console.error('Error during post-login initialization:', error)
      throw error
    }
  }

  return {
    // Computed properties
    userInfo,
    regionConfig,
    defaultMetric,
    userDefaultInitView,
    userRole,
    isBasicUser,
    defaultView,

    // Methods
    setRegionCurrency,
    initializeDefaultMetric,
    getPostLoginRoute,
    performPostLoginInit
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/compositions/UsePostLoginInit.js